import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss']
})
export class PaymentMethodsComponent implements OnInit {
  public paymentMethods:any;
  public loading:boolean=true;
  public newNumber:number;
  public newExpireMonth:number;
  public newExpireYear:number;
  public newCvc:number;

  constructor(
    private _acc: AccountService
  ) { }

  ngOnInit() {
    this.getPaymentMethods();
  }

  private getPaymentMethods(){
    this._acc.getUserPaymentMethods().subscribe(
      res=>{
        this.paymentMethods=res.data;
        this.loading=false;
      }
    );
  }

  public addNewCard(){
    if(!this.newNumber || this.newNumber.toString().length != 16){
      return alert('Invalid card number');
    }
    if(!this.newExpireMonth || this.newExpireMonth.toString().length != 2){
      return alert('Invalid expiry month');
    }
    if(!this.newExpireYear || this.newExpireYear.toString().length != 4){
      return alert('Invalid expiry year');
    }
    if(!this.newCvc || this.newCvc.toString().length != 3){
      return alert('Invalid CVC');
    }
    this._acc.addNewCard(this.newNumber, this.newExpireMonth, this.newExpireYear, this.newCvc).subscribe(res=>{
      this.getPaymentMethods();
      this.newNumber=null;
      this.newExpireMonth=null;
      this.newExpireYear=null;
      this.newCvc=null;
    });
  }

  public removeCard(id){
    if(confirm('Remove this card from the system?')){
      this._acc.removeCard(id).subscribe(
        res=>{
          console.log(res);
          this.getPaymentMethods();
        }
      );
    }
  }
}
